import CardSquare from '@/common/components/cardSquare/CardSquare';
import { Link } from 'react-router-dom';
import DocumentsIcon from '@/common/assets/icons/documents.svg?react';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks';
import { DocumentsCardProps } from '@/modules/FileDetail/components/entryTabs/Cards/DocumentsCard/DocumentsCard.types';

const DocumentsCard = ({ title }: DocumentsCardProps) => {
  return (
    <Link to={FILE_DETAIL_LINKS.documentation}>
      <CardSquare title={title} renderIcon={() => <DocumentsIcon />} />
    </Link>
  );
};
export default DocumentsCard;
